import * as React from 'react';
import { Button } from 'antd';
import style from './BackButton.module.scss';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined } from '@ant-design/icons';

interface BackButtonProps {
    onClick: () => void;
    title?: string;
    variant?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, title, variant }) => {
    const { t } = useTranslation('common');

    if (variant === 'arrow') {
        return (
            <Button
                size={'small'}
                type={'text'}
                className={style.arrowBtn}
                onClick={onClick}>
                <ArrowLeftOutlined />
                {!title ? t('back') : title}
            </Button>
        );
    }
    return (
        <Button
            size={'small'}
            type={'text'}
            className={style.btn}
            onClick={onClick}>
            {!title ? t('back') : title}
        </Button>
    );
};

export default BackButton;
